import React, {useEffect, useMemo, useState} from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import {ProgressSpinner} from 'primereact/progressspinner';
import {formatCrmDateTime, formatCrmHistoryValue, translateCrmHistoryEvent, translateCrmHistoryField} from './crmFormatters';

const CrmTimelineComponent = ({t, leadId, dealId, taskId, refreshToken = 0}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const headers = useMemo(() => ({Authorization: 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')}), []);
  useEffect(() => {
    const params = leadId ? {leadId} : dealId ? {dealId} : {taskId};
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/crm/timeline', {headers, params})
      .then(response => setItems(response.data.data.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
      .finally(() => setLoading(false));
  }, [dealId, headers, leadId, refreshToken, taskId, t]);
  if (loading && !items.length) return <div className="p-text-center p-p-3"><ProgressSpinner style={{width: 32, height: 32}}/></div>;
  if (!items.length) return <div className="p-text-secondary p-py-2">{t('crmNoHistory')}</div>;
  return <div className={'crm-timeline ' + (loading ? 'crm-timeline-refreshing' : '')}>{items.map(item => <div className="crm-timeline-item" key={item.source + '-' + item.id}>
    <span className="crm-timeline-dot"/><div><strong>{item.source === 'HISTORY' ? translateCrmHistoryEvent(item.type, t) : item.type}</strong>{item.field_name && <span> · {translateCrmHistoryField(item.field_name, t)}</span>}<small>{formatCrmDateTime(item.date, t)}{item.employee_name ? ' · ' + item.employee_name : ''}</small>{item.note && <p>{item.note}</p>}{(item.old_value || item.new_value) && <p>{formatCrmHistoryValue(item.old_value, item.field_name, t)} → {formatCrmHistoryValue(item.new_value, item.field_name, t)}</p>}</div>
  </div>)}</div>;
};

export default withTranslation('common')(CrmTimelineComponent);
